export default __webpack_public_path__ + "assets/879ef5457194f29ff548dc19e22492cf.jpg";